
/**
 * Utility function to clamp a value between min and max.
 * @param {number} value - The value to clamp.
 * @param {number} min - The minimum allowed value.
 * @param {number} max - The maximum allowed value.
 * @returns {number} - The clamped value.
 */
export const clamp = (value, min, max) => Math.max(min, Math.min(value, max));

/**
 * Utility function to snap a value to the nearest grid point.
 * @param {number} value - The value to snap.
 * @param {number} gridSize - The size of the grid.
 * @param {boolean} snapEnabled - Flag to enable or disable snapping.
 * @returns {number} - The snapped value.
 */
export const snapToGridFn = (value, gridSize, snapEnabled) => {
  if (!snapEnabled) return value;
  return Math.round(value / gridSize) * gridSize;
};

export const boundDrag = (pos, scale, snapToGridEnabled, gridSize, screenWidth, screenHeight, objectWidth, objectHeight) => {
  let x = pos.x / scale;
  let y = pos.y / scale;

  // Apply snapping to grid if enabled
  if (snapToGridEnabled) {
    x = snapToGridFn(x, gridSize, snapToGridEnabled);
    y = snapToGridFn(y, gridSize, snapToGridEnabled);
  }

  // Clamp the positions within the screen bounds
  x = clamp(x, 0, (screenWidth - objectWidth));
  y = clamp(y, 0, (screenHeight - objectHeight));

  // Apply scaling
  x *= scale;
  y *= scale;

  return {
    x,
    y
  };
};
